<mat-form-field class="full-width" [class.ts-selector--error]="!!error" floatLabel="never">
  <div class="independent-display-text" [class.hint-text]="selectedCount === 0">
    {{ displayName }}
    <span *ngIf="selectedCount > 1">
      (+{{ (selectedCount || 0) - 1 }}
      {{ selectedCount === 2 ? ('label.other' | translate) : ('label.others' | translate) }})
    </span>
  </div>
  <mat-select [attr.aria-label]="ariaLabel" multiple tsMatSelectInfiniteScroll
    (lastItemReached)="lastItemReached.emit()" [compareWith]="checkIfItemIsSelected" [value]="selected"
    (selectionChange)="selectionChanged($event.value)" [attr.data-cy]="dataCy">
    <mat-select-trigger class="transparent-trigger">
      <!-- Transparent trigger - actual text is displayed independently above -->
    </mat-select-trigger>

    <div class="sticky-checkbox">
      <ts-search-bar *ngIf="searchable" class="flex-grow-1 search-bar-margin" [searchValue]="searchTerm"
        (searchChanged)="searchTermChanged.emit($event)"></ts-search-bar>

      <mat-checkbox class="all-items-checkbox" (change)="toggleAllItems($event)"
        [indeterminate]="isIndeterminateChecked" [checked]="isCompletelyChecked">{{ 'core.all' | translate }}<span
          *ngIf="totalAvailable"> ({{ totalAvailable }})</span></mat-checkbox>
      <mat-divider></mat-divider>
    </div>

    <div *ngIf="error" class="error-message" role="alert">
      <i class="ri-error-warning-line" aria-hidden="true"></i>
      <span>{{ error | translate }}</span>
    </div>

    <!-- Item options -->
    <mat-option *ngFor="let item of allOptions" [value]="item">{{ getDisplayValue(item) }}</mat-option>

    <!-- Hidden option to allow dropdown to open when no items -->
    <mat-option *ngIf="loaded && (!allOptions || allOptions.length === 0)" disabled style="display: none"></mat-option>

    <!-- Loading indicator -->
    <div *ngIf="!loaded" class="spinner-container">
      <mat-spinner diameter="24"></mat-spinner>
    </div>

    <!-- No items message -->
    <div class="flex-row align-items-center justify-content-center" style="margin: 0 auto; padding: 48px"
      *ngIf="loaded && (!allOptions || allOptions.length === 0)">
      {{ noItemsMessage || ('info.no_items' | translate) }}
    </div>
  </mat-select>
</mat-form-field>
